import Header from "@commons/header";
import Column from "@components/column";
import React from "react";
import CouponForm from "./form";
import CouponList from "./list";
import { Gift } from "lucide-react";

const CouponSetup = ({ role, state }: { role: string; state?: any }) => {
  return (
    <Column>
      <Header title="Coupon Setup" icon={Gift} />
      <CouponForm role={role} state={state} />
      <CouponList state={state} />
    </Column>
  );
};

export default CouponSetup;
